import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get("admin/fabric-order/page", params)
const getDetail = id => get(`admin/fabric-order/${id}`)
const putData = params => put(`admin/fabric-order/${params.id}`, params)
const postData = params => post(`admin/fabric-order`, params)
const getListOrder = params =>
  get(`admin/fabric-order/trading-company/${params.id}/order/list`, params)
const getListNumber = params =>
  get(`admin/fabric-order/trading-company/${params.id}/number/list`, params)
const getListCustomer = params =>
  get(`admin/fabric-order/trading-company/${params.id}/customer-name/list`)
const getListBunch = params =>
  get(`admin/fabric-order/trading-company/${params.id}/bunch/list`, params)
const getListBrand = params =>
  get(`admin/fabric-order/trading-company/${params.id}/brand/list`)
const getGrandTotal = () => get(`admin/fabric-order/grand-total`)

const FabricOrderAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
  getListOrder,
  getListNumber,
  getListCustomer,
  getListBunch,
  getListBrand,
  getGrandTotal,
}

export default FabricOrderAPI
